import { connect } from "react-redux";
import AttendeeList from ".";
import { Dispatch } from "@reduxjs/toolkit";
import {
  AttendeeInfo,
  IAttendeeInfoCompact,
  IAttendeeStatusRequest,
} from "@/services/attendee-service/entity/AttendeeEntity";
import { deleteAttendee } from "@/redux/slices/resources/ResourceSlice";
import { SearchResponse } from "@/fetchInterceptor/AxiosMethod";
import { IAttendeeService, TokenIAttendeeService } from "@/services/attendee-service/IAttendeeService";
// import { FORMAT_DATE_DEFAULT, TimeFunction } from "@/common/datetime/TimeFunction";
// import { cloneDeep } from "lodash";
import { baContainer } from "@/ioc";

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  const attendeeService: IAttendeeService = baContainer.resolve(
    TokenIAttendeeService
  );
  return {
    onDeleteAttendee: (attendeeInfo: AttendeeInfo) => {
      dispatch(deleteAttendee(attendeeInfo));
    },
    onGetAttendeeStatus: (
      request: IAttendeeStatusRequest,
      attendees: AttendeeInfo[],
      isNextDate?: boolean
    ): Promise<SearchResponse<AttendeeInfo>> => {
      const mapAttendee: Record<string, IAttendeeInfoCompact> = {}
      attendees.forEach(item => {
        mapAttendee[item.email] = {
          name: item.name,
          isOrganizer: !!item.isOrganizer
        };
      });
      return attendeeService.getScheduleAttendee(request, mapAttendee, isNextDate).then((res) => res);
    },
  };
};

export default connect(null, mapDispatchToProps)(AttendeeList);
